export const EMPTY_RETRY_MS = 60 * 1000;
export const REFRESH_MS = 30 * 60 * 1000;

export type RefreshStatus = {
    inFlight: boolean;
    lastAttemptAt: number;
    lastAttemptOk: boolean;
};

export const shouldRefresh = (status: RefreshStatus, isEmpty: boolean, now: number, hidden: boolean): boolean => {
    if (status.inFlight) return false;
    if (isEmpty && !status.lastAttemptOk) return true;
    return !hidden && now - status.lastAttemptAt >= REFRESH_MS;
};
